// Shell frame – fixní header + viewport + volitelná spodní lišta
// Rozděluje shell na fixní horní oblast (hlavní menu), navigační viewport
// a fixní spodní legacy lištu. Embedded režim chrome skrývá – patří hostiteli.

import type { ReactNode } from 'react';
import { useShellMode } from './useShellMode';

interface NavigationShellFrameProps {
  /** Navigační obsah pod fixed headerem */
  children: ReactNode;
  /** Slot pro hlavní menu – renderuje se pouze ve standalone režimu */
  mainMenu?: ReactNode;
  /** Slot pro spodní legacy lištu – renderuje se pouze ve standalone režimu */
  footer?: ReactNode;
}

/**
 * Shell frame – rozděluje aplikaci na fixní header (hlavní menu),
 * navigační viewport (každá vrstva si drží vlastní scrollbar) a fixní
 * spodní legacy lištu. V embedded režimu se chrome (menu + footer) skryje,
 * protože patří legacy hostiteli.
 */
export function NavigationShellFrame({ children, mainMenu, footer }: NavigationShellFrameProps) {
  const shellMode = useShellMode();
  const showChrome = shellMode === 'standalone';

  return (
    <div className="flex h-full flex-col">
      {/* Pevná horní oblast – pouze hlavní menu */}
      {showChrome && mainMenu && <header className="shrink-0">{mainMenu}</header>}

      {/* Navigační viewport – flex-1 nechá výšku přesně mezi chrome */}
      <div className="relative flex-1 overflow-hidden" data-testid="shell-viewport">
        {children}
      </div>

      {/* Fixní spodní lišta – kompaktní legacy chrome */}
      {showChrome && footer && <div className="shrink-0">{footer}</div>}
    </div>
  );
}
